/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-statements */
/* eslint-disable no-console */
/* eslint-disable no-undef */
import React, { useState, useEffect, useContext } from 'react';
import { Loader } from '../../components/Loader/Loader';
import { createAuthOConnection } from './initiateAuthO';
import { useLoginApi } from '../../apiHooks/apiHooks';
import { AppContextData } from '../AppContext';
export const Auth0ProviderProxy = (authOProps) => {
  const { handleAuthLoginApi } = useLoginApi();
  const { state } = useContext(AppContextData);
  const [isAuthenticated, setIsAuthenticated] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function initiateAuthOLogin () {
      let url = new URL(window.location);
      try {
        if(authOProps?.redirect_uri.startsWith('https://')) {
          url = new URL(authOProps.redirect_uri);
          if(url.hostname !== window.location.host) {
            throw 'Redirect URI not same as current host: current host: ' + window.location.host
              + 'redirect URI: ' + authOProps.redirect_uri;
          }
        } else if(authOProps?.redirect_uri !== window.location.host) {
          throw 'Redirect URI not same as current host: current host: ' + window.location.host
              + ' redirect URI: ' + authOProps.redirect_uri;
        }
        const auth0FromHook = await createAuthOConnection(authOProps.authType);
        if ( authOProps.state && authOProps.state.code && authOProps.state.state) {
          if(auth0FromHook && await authenticateToken(auth0FromHook)) {
            return null;
          }
        }
        const isAuthenticated = await auth0FromHook.isAuthenticated();
        setIsAuthenticated(isAuthenticated);
        if (isAuthenticated) {
          if(await authenticateToken(auth0FromHook)) {
            return null;
          }
        } else {
          await auth0FromHook.loginWithRedirect({ languagekey: authOProps.language || 'en', source: 'web', domain: url?.hostname || window.location.host, scope: 'openid offline_access profile email' });
        }
      } catch(e) {
        console.log(e);
        window.location.href = authOProps.redirect_uri + `?org=${state.org_id}&app=user&env=${state.env_id}`;
      }
      setLoading(false);
      return null;
    })();
    const authenticateToken = async (auth0FromHook) => {
      if (authOProps?.state?.state &&
        authOProps?.state?.code) {
        const params = new URLSearchParams(window.location.search);
        params.set('code', authOProps.state.code);
        params.set('state', authOProps.state.state);
        window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
        await auth0FromHook.handleRedirectCallback();
      }
      const accessToken = await auth0FromHook.getTokenSilently();
      if(accessToken) {
        const idToken = await auth0FromHook.getIdTokenClaims();
        await handleAuthLoginApi(state, idToken, auth0FromHook, accessToken);
        return true;
      }
      return null;
    };
  }, []);

  return (
    <div>
      {!isAuthenticated && loading? <Loader type='fullScreen'/> : null}
    </div>
  );
};

export const Auth0Provider = Auth0ProviderProxy;
